import { useMutation, useQueryClient } from "react-query";
import { mutateDeleteFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";
import { Auth } from "../../interface";

export const useDeleteCoupon = () => {
  const queryClient = useQueryClient();
  return useMutation<Auth, never, any>(
    (data) => mutateDeleteFn(ENDPOINTS.DELETE_COUPON, data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries([]);
      },
    }
  );
};
